import { render, staticRenderFns } from "./mobile-login-footer.vue?vue&type=template&id=4dc9826e&scoped=true&"
import script from "./mobile-login-footer.vue?vue&type=script&lang=js&"
export * from "./mobile-login-footer.vue?vue&type=script&lang=js&"
import style0 from "./mobile-login-footer.vue?vue&type=style&index=0&id=4dc9826e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc9826e",
  null
  
)

export default component.exports